var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVitalScan(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.94279 2.89697H4.91988C4.38337 2.89697 3.86884 3.1101 3.48947 3.48947C3.1101 3.86884 2.89697 4.38337 2.89697 4.91988V6.94279M2.89697 17.0573V19.0802C2.89697 19.6167 3.1101 20.1313 3.48947 20.5107C3.86884 20.89 4.38337 21.1031 4.91988 21.1031H6.94279M17.0573 21.1031H19.0802C19.6167 21.1031 20.1313 20.89 20.5107 20.5107C20.89 20.1313 21.1031 19.6167 21.1031 19.0802V17.0573M21.1031 6.94279V4.91988C21.1031 4.38337 20.89 3.86884 20.5107 3.48947C20.1313 3.1101 19.6167 2.89697 19.0802 2.89697H17.0573",
    stroke: "#444242",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0002 12.0001C13.676 12.0001 15.0345 10.6416 15.0345 8.96576C15.0345 7.28993 13.676 5.9314 12.0002 5.9314C10.3244 5.9314 8.96582 7.28993 8.96582 8.96576C8.96582 10.6416 10.3244 12.0001 12.0002 12.0001Z",
    stroke: "#444242",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0572 16.0458C17.0572 13.8105 14.7925 12 11.9999 12C9.20727 12 6.94263 13.8105 6.94263 16.0458",
    stroke: "#444242",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVitalScan);
export default __webpack_public_path__ + "static/media/Vital Scan.4bcb804de46c858ad7cfcb0d583fc146.svg";
export { ForwardRef as ReactComponent };